module.exports = __webpack_public_path__ + "img/1478.1d5f2260.png";